import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'simple-input-dialog',
    styleUrls: ['./simple-input-dialog.component.scss'],
    template: `
    <h2 mat-dialog-title>{{data?.title}}</h2>
    <mat-dialog-content class="mat-typography">
    <p>{{data?.text}}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
    <button class="color" mat-button mat-dialog-close>Cancel</button>
    <span class="spacer"></span>
    <button class="color" mat-button (onclick)="setOverrideBoolTrue()" [mat-dialog-close]="setOverrideBoolTrue()">Override</button>
    </mat-dialog-actions>
    `
})
export class ModalOverrideInput {
    constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<ModalOverrideInput>) {
        dialogRef.disableClose = true;
     }

    setOverrideBoolTrue(){
        this.data.override == true;
        return true;
    }
}